import { apiRequest } from '../core';


export function getTrainingMaterials(skip, take, query) {
  const url = new URL(`${process.env.REACT_APP_BACKEND_HOST}/api/TrainingMaterials/GetTrainingMaterials`);

  const params = {};
  if (take) {
    params.take = take;
  }
  if (skip) {
    params.skip = skip;
  }
  if (query) {
    params.query = query;
  }

  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return apiRequest(url);
}

